"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _table = require("./table.style");

var _Button = require("../Button/Button");

var _generateRandomId = require("../../utils/generateRandomId");

var _tableRow = _interopRequireDefault(require("./tableRow"));

var _tableGrid = _interopRequireDefault(require("./tableGrid"));

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Table = function Table(props) {
  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _table.useStyles)(props);
  var type = props.type,
      content = props.content,
      header = props.header,
      addFeature = props.addFeature,
      addFeatureText = props.addFeatureText,
      onClick = props.onClick,
      multiple = props.multiple,
      onItemSelect = props.onItemSelect,
      onSelectAll = props.onSelectAll;
  var tableId = (0, _generateRandomId.generateRandomId)(5); // const tableRef = useRef();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      selectAll = _useState2[0],
      setSelectAll = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      all = _useState4[0],
      setAll = _useState4[1]; // const selected = (type, ref) => {
  //     const tableElement = tableRef.current;
  //     let selectedClass = type === "table" ? classes.listSelected : classes.gridSelected;
  //     let selectedElement = ref.current;
  //
  //     for (let i = 0; i < tableElement.children.length; i++) {
  //         if (tableElement.children[i].classList.contains(selectedClass))
  //             tableElement.children[i].classList.remove(selectedClass);
  //     }
  //
  //     switch (type) {
  //         case "table":
  //             return (selectedElement.className += ` ${classes.listSelected}`);
  //         case "grid":
  //             return (selectedElement.className += ` ${classes.gridSelected}`);
  //     }
  // };


  var handleSelectAll = function handleSelectAll(e) {
    onSelectAll(e);
    setAll(!all);
    setSelectAll(!all);
  };

  var headers = /*#__PURE__*/_react["default"].createElement("li", {
    className: "".concat(classes.tableHeader),
    role: "rowgroup"
  }, multiple && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.col),
    "data-name": "multiple"
  }, /*#__PURE__*/_react["default"].createElement(_.Checkbox, {
    label: "\u0647\u0645\u0647",
    size: "sm",
    onChange: handleSelectAll,
    checked: all
  })), content.headers.map(function (header, headerKey) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(classes.col),
      key: headerKey,
      "data-name": header.rowName
    }, header.name);
  }));

  var tableContent = content.contents.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_tableRow["default"], {
      size: props.size,
      item: item,
      headers: content.headers,
      key: item.id,
      index: index,
      onChange: props.onChange,
      multiple: multiple,
      handleUnselectAll: function handleUnselectAll() {
        return setAll(false);
      },
      handleSelectAll: selectAll,
      onItemSelect: onItemSelect
    });
  });
  var card = content.contents.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_tableGrid["default"], {
      item: item,
      headers: content.headers,
      key: item.id,
      index: index,
      onChange: props.onChange
    });
  });

  if (type === "list") {
    return /*#__PURE__*/_react["default"].createElement("ul", {
      className: "".concat(classes.table),
      id: tableId,
      role: "table"
    }, header && headers, props.loading ? /*#__PURE__*/_react["default"].createElement(_.Loading, null) : /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.tableBody,
      role: "rowgroup"
    }, tableContent), addFeature && /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(classes.newList)
    }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      outline: true,
      color: "mother",
      size: "md",
      onClick: onClick
    }, addFeatureText)));
  } else {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(classes.cardRow),
      id: tableId
    }, card, addFeature && /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(classes.col4)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(classes.newGrid)
    }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      outline: true,
      color: "mother",
      size: "md",
      onClick: onClick
    }, addFeatureText))));
  }
};

exports.Table = Table;
Table.propTypes = {
  /** Table type */
  type: _propTypes["default"].oneOf(["grid", "list"]),

  /** Content type */
  content: _propTypes["default"].object,

  /** Table header */
  header: _propTypes["default"].bool,

  /** Table header */
  addFeature: _propTypes["default"].bool,

  /** show loading */
  loading: _propTypes["default"].bool,

  /** Any row can have a checkbox and user can be able select all row*/
  multiple: _propTypes["default"].bool,

  /** return selected component outer */
  onItemSelect: _propTypes["default"].func,

  /** return select all event outer */
  onSelectAll: _propTypes["default"].func
};
Table.defaultProps = {
  type: "list",
  header: true,
  addFeature: false,
  loading: false,
  onChange: function onChange() {},
  content: [],
  multiple: false,
  onItemSelect: function onItemSelect() {},
  onSelectAll: function onSelectAll() {}
};